import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import { DateField } from '@mui/x-date-pickers/DateField';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { deviceStatusMapper } from './deviceStatusMap';

export const DeviceStateCheckboxes = ({ deviceStates, onChange, mapper = deviceStatusMapper }) => {
    return (
        <>
            {Object.keys(deviceStates).map((state, index) => (
                <FormControlLabel
                key={index}
                control={
                    <Checkbox
                    checked={deviceStates[state] || false}
                    onChange={onChange(state)}
                    />
                }
                label={mapper[state]}
                />
            ))}
        </>
    );
};

export const DateAndTimeFields = ({ label, dateValue, timeValue, onDateChange, onTimeChange }) => {
    return (
        <Stack spacing={2}>
            <DateField
                label={`${label} Ημερομηνία`}
                value={dateValue}
                onChange={(newValue) => onDateChange(newValue)}
                format="DD-MM-YYYY"
                fullWidth
            />
            <TimePicker
                label={`${label} Ώρα`}
                value={timeValue}
                views={['hours']}
                ampm={false}
                onChange={(newValue) => onTimeChange(newValue)}
                slotProps={{ textField: { fullWidth: true } }}
            />
        </Stack>
    );
};
  